export default {
  // //出差申请
  // BusinessApplyForm: require("../assets/image/icon/出差申请.png"),
  // //出差审批
  // BusinessCheckList: require("../assets/image/icon/出差审批.png"),
  // //出差查询
  // BusinessApplyList: require("../assets/image/icon/出差查询.png"),
}
